export default __webpack_public_path__ + "locales/hy-AM/OAuth.json?hash=70dbe3d3eff9a5e8a52baf710d6b2388";